import { useMemo, useState } from 'react';
import './noPeopleSelect.css';

export default function NoPeopleSelect({
    data,
    selectedItems,
    setSelectedItems,
    setShowSelector,
    packData,
    booking,
    setBooking
}) {
    const [showDetails, setShowDetails] = useState(false);
    const [isReserveChecked, setIsReserveChecked] = useState(booking?.amountPaid?.isReserved);

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsReserveChecked(checked);
        handleReservePay(checked);
    };

    const handleReservePay = (checked) => {
        setBooking((prev) => ({
            ...prev,
            amountPaid: {
                ...prev.amountPaid,
                isReserved: checked
            }
        }));
    };
    const increase = (item) => {
        setSelectedItems((prev) => {
            const existing = prev[item._id] || {
                ...item,
                qty: 0
            };

            return {
                ...prev,
                [item._id]: {
                    ...existing,
                    qty: existing.qty + 1
                }
            };
        });
    };

    const decrease = (item) => {
        setSelectedItems((prev) => {
            const existing = prev[item._id];

            if (!existing) return prev;

            const qty = existing.qty - 1;

            if (qty <= 0) {
                const updated = { ...prev };
                delete updated[item._id];
                return updated;
            }

            return {
                ...prev,
                [item._id]: {
                    ...existing,
                    qty
                }
            };
        });
    };

    const summary = useMemo(() => {
        const items = Object.values(selectedItems);

        const grandTotal = items.reduce((sum, item) => sum + item.actual * item.qty, 0);

        const reserveTotal = items.reduce((sum, item) => sum + item.reserve * item.qty, 0);

        const totalTravellers = items.reduce((sum, item) => sum + item.count * item.qty, 0);

        return {
            items,
            grandTotal,
            reserveTotal,
            totalTravellers
        };
    }, [selectedItems]);

    return (
        <div className='ts-wrapper'>
            {/* CONTENT */}
            <div className='ts-content'>
                <div className='ts-header'>
                    <h2>Select Travellers</h2>
                    <p>Choose the number of travellers for each package.</p>
                    {packData?.price[0]?.reserve !== 0 && (
                        <div className='reserve-card'>
                            <input
                                type='checkbox'
                                id='reserve'
                                checked={isReserveChecked}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor='reserve' className='reserve-content'>
                                <div className='reserve-row'>
                                    <span className='reserve-title'>
                                        Reserve Now
                                        {/* {booking?.reserveTotal
                                        ? Math.round(booking.reserveTotal)
                                        : Math.round(packData?.price?.[0]?.reserve || 0)}
                                    {!booking?.reserveTotal && ' / person'} */}
                                    </span>
                                </div>
                                <div className='reserve-subtitle'>Pay the remaining amount on the activity</div>
                            </label>
                        </div>
                    )}
                </div>

                <div className='ts-cards'>
                    {data.map((item) => {
                        const qty = selectedItems[item._id]?.qty || 0;

                        const subtotal = qty * item.actual;

                        const peopleText = item.count === 1 ? 'Per Traveller' : `For ${item.count} Travellers`;

                        return (
                            <div key={item._id} className={`ts-card ${qty > 0 ? 'ts-card-active' : ''}`}>
                                {/* LEFT */}
                                <div className='ts-card-left'>
                                    <div className='ts-card-title'>
                                        <h3>{item.name}</h3>
                                    </div>

                                    <div className='ts-price-row'>
                                        {item.higherPrice && <span className='ts-old-price'>₹{item.higherPrice}</span>}

                                        <span className='ts-price'>₹{item.actual}</span>
                                        {item.discountPer && (
                                            <span className='ts-discount'>{item.discountPer}% OFF</span>
                                        )}

                                        <span className='ts-person-text'>{peopleText}</span>
                                    </div>
                                    <div className='ts-reserve-row'>
                                        {' '}
                                        <small className='reserveText'>Reserve Now at ₹{item.reserve}</small>
                                    </div>

                                    <div className='ts-terms'>
                                        {item.terms?.map((term, index) => (
                                            <p key={index}>✓ {term}</p>
                                        ))}
                                    </div>
                                </div>

                                {/* RIGHT */}
                                <div className='ts-card-right'>
                                    <div className='ts-counter'>
                                        <button type='button' disabled={qty === 0} onClick={() => decrease(item)}>
                                            −
                                        </button>

                                        <span>{qty}</span>

                                        <button type='button' onClick={() => increase(item)}>
                                            +
                                        </button>
                                    </div>

                                    {qty > 0 && (
                                        <div className='ts-subtotal'>
                                            <span>
                                                ₹{item.actual} × {qty}
                                            </span>

                                            <strong>₹{subtotal}</strong>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* FOOTER */}
            <div className='ts-footer'>
                <div className='ts-footer-top'>
                    <div className='ts-summary'>
                        {summary.totalTravellers === 0 ? (
                            <>
                                <span>No travellers selected</span>
                                <h2>₹0</h2>
                            </>
                        ) : (
                            <>
                                <span>
                                    {summary.totalTravellers} Traveller
                                    {summary.totalTravellers > 1 ? 's' : ''}
                                </span>

                                <h2>₹{summary.grandTotal}</h2>

                                <small>Reserve Now at ₹{summary.reserveTotal}</small>
                            </>
                        )}
                    </div>

                    {/* {summary.items.length > 0 && (
                        <button
                            type='button'
                            className='ts-details-button'
                            onClick={() => setShowDetails(!showDetails)}
                        >
                            {showDetails ? '▲ Hide Details' : '▼ View Details'}
                        </button>
                    )} */}
                </div>

                {/* DETAILS */}
                {/* {showDetails && (
                    <div className='ts-details'>
                        {summary.items.map((item) => (
                            <div key={item._id} className='ts-detail-row'>
                                <div>
                                    <strong>{item.name}</strong>

                                    <small>
                                        ₹{item.total} × {item.qty}
                                    </small>
                                </div>

                                <strong>₹{item.total * item.qty}</strong>
                            </div>
                        ))}
                    </div>
                )} */}

                {/* CONTINUE */}
                <button
                    type='button'
                    className='ts-continue'
                    disabled={summary.totalTravellers === 0}
                    onClick={() => setShowSelector(false)}
                >
                    Continue
                    {summary.totalTravellers > 0 && ` (${summary.totalTravellers})`}
                </button>
            </div>
        </div>
    );
}
